exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "/*---------------------------------------------------------------------------------------------\n *  Copyright (c) Microsoft Corporation. All rights reserved.\n *  Licensed under the MIT License. See License.txt in the project root for license information.\n *--------------------------------------------------------------------------------------------*/\n\n.monaco-editor .lightbulb-glyph {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\theight: 16px;\n\twidth: 16px;\n}\n\n.monaco-editor .lightbulb-glyph.hidden {\n\tdisplay: none;\n\tvisibility: hidden;\n}\n\n.monaco-editor .lightbulb-glyph:hover {\n\tcursor: pointer;\n}\n\n.monaco-editor.vs .lightbulb-glyph {\n\tbackground: url(" + require("./lightbulb.svg") + ") center center no-repeat;\n}\n\n.monaco-editor.vs-dark .lightbulb-glyph,\n.monaco-editor.hc-black .lightbulb-glyph {\n\tbackground: url(" + require("./lightbulb-dark.svg") + ") center center no-repeat;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./submodules/vscode/src/vs/editor/contrib/quickFix/browser/lightBulbWidget.css
// module id = 608
// module chunks = 0